import React from 'react';
import { Link, browserHistory } from 'react-router';
import {
  NoiDungKienNghi
} from './sub-view';
import moment from 'moment';
import { ContainerFileDinhKem } from 'components/upload';
import { TextMessage, Text } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import { RowItemChiTietThanhVienCuocThanhTraView } from 'modules/thanh-tra/datatable';
import { Dialog } from "@blueprintjs/core";
import { connect } from 'react-redux';
import { ThanhTra } from 'api';
import { Toastr } from 'modules/toastr';
import { get, isEmpty } from 'lodash';
import {
  RowItemCanCuCuocThanhTraView
} from 'modules/thanh-tra/datatable';
class ChiTietCuocThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      dataDetail: [],
      id: this.props.params.id,
      showFile: false,
      listDoiTuongViPham: [],
      dataDonViBanHanh: [],
      dataCanCuThanhTraLai: [],
      type: this.props.type,
      showDoiTuongThanhTra: false,
      tienDoThanhTra: false,
    }
  }

  componentDidMount() {
    this.getDataCanCuThanhTraLai();
    this.getDetail(this.state.id);
    this.getDonViBanHanh();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.tienDoThanhTra !== prevState.tienDoThanhTra) {
      this.setState({
        ...this.state,
        tienDoThanhTra: this.state.tienDoThanhTra
      })
    }
  }

  getDataCanCuThanhTraLai() {
    ThanhTra.actions.getCanCuThanhTraLai.request().then(res => {
      if (res.data) {
        this.state.dataCanCuThanhTraLai = res.data;
        this.setState({
          ...this.state
        })
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      id: nextProps.params.id,
      type: nextProps.type
    })
  }

  getDetail(id) {
    ThanhTra.actions.getChiTietCuocThanhTra.request({ id: id }).then(res => {
      if (res.data) {
        this.setState({
          dataDetail: res.data,
          tienDoThanhTra: res.data.tienDoThanhTra,
        }, () => {
          this.checkListDoiTuongViPham();
          this.getChiTietLienQuanCuocThanhTra(id);
        })
      }
    })
  }

  getChiTietLienQuanCuocThanhTra(id) {
    ThanhTra.actions.getChiTietLienQuanCuocThanhTra.request({ id: id }).then(res => {
      if (res.data) {
        let data = res.data;
        this.setState({
          dataDetail: {
            ...this.state.dataDetail,
            listTaiLieuVanThu: data.listTaiLieuVanThu || [],
            listTaiLieuVanThuGiaHan: data.listTaiLieuVanThuGiaHan || [],
            listTaiLieuVanThuKetLuanThanhTra: data.listTaiLieuVanThuKetLuanThanhTra || [],
            listTaiLieuVanThuThongBaoKetThucTTTT: data.listTaiLieuVanThuThongBaoKetThucTTTT || [],
            listTaiLieuVanThuThongTinCuocThanhTra: data.listTaiLieuVanThuThongTinCuocThanhTra || [],
            listTaiLieuKetLuanThanhTraRutGon: data.listTaiLieuKetLuanThanhTraRutGon || [],
            listTaiLieuVanThuQuyetDinhGiamSat: data.listTaiLieuVanThuQuyetDinhGiamSat || [],
          }
        }, () => {
          this.setState({
            showFile: true
          });
        });
      }
    });
  }

  getDonViBanHanh() {
    ThanhTra.actions.getListDonViBanHanh.request().then(res => {
      if (res.data) {
        this.setState({
          dataDonViBanHanh: res.data
        })
      }
    })
  }

  checkListDoiTuongViPham() {
    let Data = this.state.dataDetail;
    let listDoiTuongViPham = [];
    let doiTuongThanhTraLienQuan = [];
    let doiTuongThanhTras = [...Data.listDoiTuongThanhTra];
    let doiTuongThanhTra = Data.doiTuongThanhTraInfo;
    let data = Data.doiTuongThanhTraLienQuan.split('; ');
    if (data.length > 0) {
      data.map(state => {
        if (state) {
          doiTuongThanhTraLienQuan[doiTuongThanhTraLienQuan.length] = {
            ten: state
          }
        }
      })
    }
    if (doiTuongThanhTraLienQuan.length > 0) {
      doiTuongThanhTraLienQuan.map(state => {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: state.ten,
          giaTri: state.ten
        }
      })
    }
    if (doiTuongThanhTras.length > 0) {
      doiTuongThanhTras.map(state => {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: state.ten,
          giaTri: state.ten
        }
      })
    }
    if (doiTuongThanhTra) {
      listDoiTuongViPham[listDoiTuongViPham.length] = {
        ten: doiTuongThanhTra.ten,
        giaTri: doiTuongThanhTra.ten
      }
    }
    this.setState({
      listDoiTuongViPham: listDoiTuongViPham
    })
  }

  onClickClose() {
    this.props.dispatch({ type: 'DSTT_GO_BACK' })
    browserHistory.goBack();
  }

  showDoiTuongThanhTra() {
    this.setState({
      showDoiTuongThanhTra: true
    })
  }

  hideDoiTuongThanhTra() {
    this.setState({
      showDoiTuongThanhTra: false
    })
  }

  getCanCuThanhTraLai(value) {
    if (this.state.dataCanCuThanhTraLai.length > 0) {
      return this.state.dataCanCuThanhTraLai[this.state.dataCanCuThanhTraLai.findIndex(x => x.giaTri == value)].ten
    } else {
      return
    }
  }

  getTitleNoiDungThamNhung() {
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const TTTrungUong = 19;
    const isTTTW = userInfo.capCoQuanQuanLyId === TTTrungUong;
    let titleNoiDungThamNhung = '';
    if (isTTTW) {
      if (this.state.type === 'KE_HOACH') {
        titleNoiDungThamNhung = '6. Nội dung tham nhũng';
      } else {
        titleNoiDungThamNhung = '5. Nội dung tham nhũng';
      }
    } else {
      if (this.state.type === 'KE_HOACH') {
        titleNoiDungThamNhung = '5. Nội dung tham nhũng';
      } else {
        titleNoiDungThamNhung = '4. Nội dung tham nhũng';
      }
    }
    return titleNoiDungThamNhung;
  }

  getTitleNoiDungKienNghi() {
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const TTTrungUong = 19;
    const isTTTW = userInfo.capCoQuanQuanLyId === TTTrungUong;
    let titleNoiDungKienNghi = '';
    if (isTTTW) {
      if (this.state.type === 'KE_HOACH') {
        titleNoiDungKienNghi = '5. Nội dung kiến nghị';
      } else {
        titleNoiDungKienNghi = '4. Nội dung kiến nghị';
      }
    } else {
      if (this.state.type === 'KE_HOACH') {
        titleNoiDungKienNghi = '4. Nội dung kiến nghị';
      } else {
        titleNoiDungKienNghi = '3. Nội dung kiến nghị';
      }
    }
    return titleNoiDungKienNghi;
  }

  render() {
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const TTTrungUong = 19;
    const isTTTW = userInfo.capCoQuanQuanLyId === TTTrungUong;
    let Data = this.state.dataDetail;
    let textTrangThai = '';
    if (Data.trangThaiThanhTraRutGon === 'DANG_THUC_HIEN') {
      textTrangThai = "Đang thực hiện";
    } else if (Data.trangThaiThanhTraRutGon === 'DA_THUC_HIEN') {
      textTrangThai = "Đã thực hiện";
    } else if (Data.trangThaiThanhTraRutGon === 'CHUA_THUC_HIEN') {
      textTrangThai = "Chưa thực hiện";
    }
    let DataDetail = this.state.dataDetail;
    let DoiTuongThanhTra = '';
    let TenDTTheoKeHoach = '';
    let chiTietDTTTTheoKeHoach = {};
    let chiTietMotDoiTuong = {};
    if (DataDetail && DataDetail.doiTuongThanhTraInfo) {
      chiTietMotDoiTuong = DataDetail && DataDetail.doiTuongThanhTraInfo;
    } else if (DataDetail && DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.length > 0) {
      chiTietMotDoiTuong = DataDetail.listDoiTuongThanhTra[0];
    }
    if (DataDetail.cuocThanhTraNhieuDoiTuong === false && DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.length > 0) {
      TenDTTheoKeHoach = DataDetail.listDoiTuongThanhTra[0].ten;
    } else if (DataDetail.cuocThanhTraNhieuDoiTuong && DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.length > 0) {
      TenDTTheoKeHoach = `${DataDetail.listDoiTuongThanhTra.length} đối tượng`;
    }
    if (Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0 && DataDetail.hinhThucThanhTra == "THEO_KE_HOACH") {
      chiTietDTTTTheoKeHoach = Data.listDoiTuongThanhTra[0] || {};
    } else {
      chiTietDTTTTheoKeHoach = Data.doiTuongThanhTraInfo || {};
    }

    if (Data.listDoiTuongThanhTra && Data.listDoiTuongThanhTra.length > 0) {
      Data.listDoiTuongThanhTra.map((state, index) => {
        if (index == 0) {
          DoiTuongThanhTra = DoiTuongThanhTra + state.ten;
        } else {
          DoiTuongThanhTra = DoiTuongThanhTra + '; ' + state.ten;
        }
      })
    }
    let dataFilter = this.state.dataDonViBanHanh.filter(state => {
      return state.giaTri == Data.donViBanHanh
    })
    let donViBanHanh = '';
    if (dataFilter.length > 0) {
      donViBanHanh = dataFilter[0].ten
    }
    if (Data.chucNangCuocThanhTra == null) {
      Data.chucNangCuocThanhTra = DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.chucNangKeHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.chucNangKeHoachThanhTraInfo.type : '';
      Data.chucNangCuocThanhTraInfo = DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.chucNangKeHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.chucNangKeHoachThanhTraInfo : {};
    }
    let titleKetLuanThanhTra = this.state.type === 'KE_HOACH' ? '3. Kết luận thanh tra' : '2. Kết luận thanh tra';
    let titleKetLuanThanhTraDayDu = this.state.type === 'KE_HOACH' ? '4. Kết luận thanh tra đầy đủ' : '3. Kết luận thanh tra đầy đủ';
    const isKiemTra = get(DataDetail, 'loaiCuoc.value') === 'KIEM_TRA';
    const loaiCuocText = isKiemTra ? 'kiểm tra' : 'thanh tra';
    const keHoachText = isKiemTra ? 'KHKT' : 'KHTT';
    return (
      <div className="center reception-container wrap-block">
        <div className="back-foward">
          <Link onClick={this.onClickClose.bind(this, 'close')} title="">Về trang trước</Link>
        </div>
        <div className="heading with-right-content">
          <h2 className="heading-title icon-add">
            Thông tin chi tiết cuộc {loaiCuocText}
          </h2>
          <ShowIf condition={get(this.state, 'tienDoThanhTra') == 'LUU_HO_SO'}>
            <p className='heading-code' onClick={() => {
              navigator.clipboard.writeText(get(DataDetail, 'hoSoThanhTra.maHoSo') || '');
              Toastr('Copy mã hồ sơ thành công.', 'success');
            }}>{get(DataDetail, 'hoSoThanhTra.maHoSo')}<span className='tt-copy'></span></p>
          </ShowIf>
        </div>
        <div className="bottom-content">
          <ShowIf condition={this.state.type === 'KE_HOACH'}>
            {/*thông tin cuộc thanh tra*/}
            <section className='wrap-block'>
              <div className='row pl15 pr15'>
                <h2 className='title-14 p20'>1. Thông tin kế hoạch {loaiCuocText}</h2>
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Năm ${loaiCuocText}:`} className='col-20' value={`Kế hoạch ${loaiCuocText} năm ${DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.namThanhTra : ''}`} />
                <Text label={`Quyết định phê duyệt ${keHoachText}:`} className='col-20' value={DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.quyetDinhPheDuyetKTTT : ''} />
                <Text label='Ngày phê duyệt:' className='col-20' value={DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh ? moment(DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
              </div>
            </section>
            {/*end thông tin cuộc thanh tra*/}
            <div className='mt10'>
              <div className='big-border'></div>
            </div>
          </ShowIf>
          {/*thông tin cuộc thanh tra*/}
          <section className='wrap-block'>
            <ShowIf condition={this.state.type === 'DOT_XUAT'}>
              <div className='row pl15 pr15'>
                <h2 className='title-14 p20'>1. Thông tin cuộc {loaiCuocText}</h2>
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Năm ${loaiCuocText}:`} className='col-25 mb10' value={Data.namThanhTra ? Data.namThanhTra : ''} />
                <div className="col-25 mb10">
                  <label className="pt-label">
                    <span className="val-title-bold">Đối tượng {loaiCuocText}:</span>
                    <span className="val-content txt-blue txt-underline cursor-pointer txt-inline-block" onClick={this.showDoiTuongThanhTra.bind(this)}>{TenDTTheoKeHoach}</span>
                  </label>
                </div>
                <Text label={`Tên cuộc ${loaiCuocText}:`} className='col-100 mb10' value={Data.ten ? Data.ten : ''} />
                <Text label={`Thời kỳ ${loaiCuocText}:`} className='col-25 mb10' value={Data.kyThanhTra ? Data.kyThanhTra : ''} />
                <Text label={`Tiến độ ${loaiCuocText}:`} className='col-25 mb10' value={Data.tienDoThanhTraInfo ? Data.tienDoThanhTraInfo.text : ''} red={true} />
                <TextMessage label={`Nội dung ${loaiCuocText}:`} className='col-100 mb10' value={Data.noiDungThanhTra ? Data.noiDungThanhTra : ''} />
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Số quyết định về việc ${loaiCuocText}:`} className='col-25 mb10' value={Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : ''} />
                <Text label='Ngày ra quyết định:' className='col-25 mb10' value={Data.ngayRaQuyetDinh ? moment(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                <Text label='Hình thức:' className='col-25 mb10' value={Data.hinhThucThanhTraInfo ? Data.hinhThucThanhTraInfo.text : ''} />
                <ShowIf condition={Data.hinhThucThanhTra === 'DOT_XUAT'}>
                  <TextMessage label={`Căn cứ ${loaiCuocText} đột xuất:`} className='col-100 mb10' value={Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : ''} />
                </ShowIf>
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Ngày công bố QĐ ${loaiCuocText}:`} className='col-25 mb10' value={Data.ngayCongBoQuyetDinhThanhTra ? moment(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : ''} />
                <Text label={`Thời hạn ${loaiCuocText} (ngày làm việc):`} type='sdt' className='col-25 mb10' value={`${Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0} ngày (${Data.ngayHetHanThanhTra ? moment(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : ''})`} />

                <Text label='Loại hình:' value={Data.loaiHinhThanhTraInfo ? Data.loaiHinhThanhTraInfo.text : ''} className='col-25 mb10' />
                <ShowIf condition={Data.loaiHinhThanhTra === 'THANH_TRA_LAI'}>
                  <Text label={`Căn cứ ${loaiCuocText} lại:`} value={Data.canCuThanhTraLai ? this.getCanCuThanhTraLai(Data.canCuThanhTraLai) : ''} className='col-100 mb10' />
                </ShowIf>
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Chức năng ${loaiCuocText}:`} className='col-25 mb10' value={Data.chucNangCuocThanhTraInfo ? Data.chucNangCuocThanhTraInfo.text : ''} />
                <ShowIf condition={Data.chucNangCuocThanhTra === 'HANH_CHINH'}>
                  <Text label={`Lĩnh vực ${loaiCuocText}:`} className='col-25 mb10' value={!isEmpty(Data, 'linhVucThanhTraList') ? get(Data, 'linhVucThanhTraList', []).map((item) => item.text).join(', ') : ''} />
                </ShowIf>
                <ShowIf condition={Data.chucNangCuocThanhTra === 'CHUYEN_NGANH'}>
                  <Text label={`Hình thức ${loaiCuocText} chuyên ngành:`} className='col-25 mb10' value={Data.hinhThucThanhTraChuyenNganhInfo ? Data.hinhThucThanhTraChuyenNganhInfo.text : ''} />
                </ShowIf>
              </div>
              {/* <div className='row pl30 pr30'>
                <Text label='Đơn vị chủ trì:' className='col-25 mb10' value={Data.donViChuTriInfo ? Data.donViChuTriInfo.ten : ''}/>
              </div> */}
            </ShowIf>
            <ShowIf condition={this.state.type === 'KE_HOACH'}>
              <div className='row pl15 pr15'>
                <h2 className='title-14 p20'>2. Thông tin cuộc {loaiCuocText}</h2>
              </div>
              <div className='row pl30 pr30'>
                <div className="col-25 mb15">
                  <label className="pt-label">
                    <span className="val-title-bold">Đối tượng {loaiCuocText}:</span>
                    <span className="val-content txt-blue txt-underline cursor-pointer txt-inline-block" onClick={this.showDoiTuongThanhTra.bind(this)}>{TenDTTheoKeHoach}</span>
                  </label>
                </div>
                <Text label={`Thời kỳ ${loaiCuocText}:`} className='col-25 mb10' value={Data.kyThanhTra ? Data.kyThanhTra : ''} />
                <Text label={`Tiến độ ${loaiCuocText}:`} className='col-25 mb10' value={Data.tienDoThanhTraInfo ? Data.tienDoThanhTraInfo.text : ''} red={true} />
                <Text label={`Tên cuộc ${loaiCuocText}:`} className='col-100 mb10' value={Data.ten ? Data.ten : ''} />
                <TextMessage label={`Nội dung ${loaiCuocText}:`} className='col-100 mb10' value={Data.noiDungThanhTra ? Data.noiDungThanhTra : ''} />
              </div>
            </ShowIf>
          </section>
          <section className='wrap-block mb10'>
            <ShowIf condition={this.state.type === 'KE_HOACH'}>
              <div className='row pl30 pr30'>
                <Text label={`Số quyết định về việc ${loaiCuocText}:`} className='col-25 mb10' value={Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : ''} />
                <Text label='Ngày ra quyết định:' className='col-25 mb10' value={Data.ngayRaQuyetDinh ? moment(Data.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                <Text label={`Ngày công bố QĐ ${loaiCuocText}:`} className='col-25 mb10' value={Data.ngayCongBoQuyetDinhThanhTra ? moment(Data.ngayCongBoQuyetDinhThanhTra).format('DD/MM/YYYY') : ''} />
                <Text label={`Thời hạn ${loaiCuocText} (ngày làm việc):`} type='sdt' className='col-25 mb10' value={`${Data.thoiHanThanhTra ? Data.thoiHanThanhTra : 0} ngày (${Data.ngayHetHanThanhTra ? moment(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : ''})`} />
              </div>
            </ShowIf>
            <div className='row pl30 pr30'>
              <Text label={`Chức năng ${loaiCuocText}:`} className='col-25 mb10' value={Data.chucNangCuocThanhTraInfo && Data.chucNangCuocThanhTraInfo.text ? Data.chucNangCuocThanhTraInfo.text : ''} />
              <ShowIf condition={this.state.type === 'KE_HOACH'}>
                <ShowIf condition={Data.chucNangCuocThanhTra !== 'CHUYEN_NGANH'}>
                  <Text label={`Lĩnh vực ${loaiCuocText}:`} className='col-25 mb10' value={!isEmpty(Data, 'linhVucThanhTraList') ? get(Data, 'linhVucThanhTraList', []).map((item) => item.text).join(', ') : ''} />
                </ShowIf>
                <ShowIf condition={Data.chucNangCuocThanhTra === 'CHUYEN_NGANH'}>
                  <Text label={`Hình thức ${loaiCuocText} chuyên ngành:`} className='col-25 mb10' value={Data.hinhThucThanhTraChuyenNganhInfo ? Data.hinhThucThanhTraChuyenNganhInfo.text : ''} />
                </ShowIf>
                <ShowIf condition={Data.hinhThucThanhTra === 'DOT_XUAT'}>
                  <TextMessage label={`Căn cứ ${loaiCuocText} đột xuất:`} className='col-100 mb10' value={Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : ''} />
                </ShowIf>
                {/* <Text label='Đơn vị chủ trì:' className='col-25 mb10' value={Data.donViChuTriInfo ? Data.donViChuTriInfo.ten : ''}/> */}
              </ShowIf>
              {/* <Text label='Đơn vị phối hợp:' className='col-100 mb10' value={Data.donViPhoiHop ? Data.donViPhoiHop : ''}/> */}
              {/* <Text label='Đối tượng thanh tra/kiểm tra:' className='col-100 mb10' value={DoiTuongThanhTra} /> */}
              <Text label={`Đối tượng ${loaiCuocText} liên quan:`} className='col-100 mb10' value={Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : ''} />
              <ShowIf condition={this.state.showFile && (this.state.dataDetail.chuyenTheoDoiThucHien === false)}>
                <div className='col-100'>
                  <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} disableAttachFile={true} dataShow={Data.listTaiLieuVanThuThongTinCuocThanhTra ? Data.listTaiLieuVanThuThongTinCuocThanhTra : []} />
                </div>
              </ShowIf>
            </div>
          </section>
          {/*end thông tin cuộc thanh tra*/}
          {/* <div className='pl20 pb20 pr20'>
              <div className='line-border'></div>
            </div> */}
          {/*Thành viên đoàn*/}
          <ShowIf condition={Data.chucNangCuocThanhTra == 'CHUYEN_NGANH'}>
            <div>
              <section className='row pl35 pr35 mb10'>
                <ShowIf condition={Data.thanhVienDoan}>
                  <div className='col-100 no-gutter'>
                    <h2 className='title-12 mb10'>{this.state.type === 'KE_HOACH' ? "2.1 Thành viên đoàn" : '1.1 Thành viên đoàn'}</h2>
                    <div className='row pl10 pr10'>
                      <Text label='Số quyết định:' className='col-25 mb0-18' value={Data.soQuyetDinhThanhLapDoan ? Data.soQuyetDinhThanhLapDoan : ''} />
                      <Text label='Ngày quyết định:' className='col-25 mb0-18' value={Data.ngayRaQuyetDinhThanhLapDoan ? moment(Data.ngayRaQuyetDinhThanhLapDoan).format('DD/MM/YYYY') : ''} />
                    </div>
                    <div className='wrap-table-show-oncheck white-table'>
                      <DataTable
                        header={header.thanhTra.TMTVCTTV}
                        dataList={Data.listThanhVienDoan ? Data.listThanhVienDoan : []}
                        pageData={this.state.pageData}
                        parent={this}
                        hideButtonExport
                        hidePagination={true}
                        search={this.state.search}
                        tableLoading={this.state.tableLoading}>
                        <RowItemChiTietThanhVienCuocThanhTraView linhVucThanhTra={Data.linhVucThanhTra ? Data.linhVucThanhTra : ''} />
                      </DataTable>
                    </div>
                  </div>
                </ShowIf>
              </section>
              <div className='pl20 pb20 pr20'>
                <div className='line-border'></div>
              </div>
            </div>
          </ShowIf>
          {/*end Thành viên đoàn*/}
          {/*Gia hạn*/}
          <ShowIf condition={Data.giaHan}>
            <section className='pl35 pr35 row'>
              <h2 className='title-12 mb15'>{this.state.type === 'KE_HOACH' ? (Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '2.2 Gia hạn' : '2.1 Gia hạn') : (Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '1.2 Gia hạn' : '1.1 Gia hạn')}</h2>
              <div className='row pl10 pr10'>
                <Text className="col-25 mb10" label='Số quyết định:' value={Data.soQuyetDinhGiaHan ? Data.soQuyetDinhGiaHan : ''} />
                <Text className="col-25 mb10" label='Ngày ra quyết định:' value={Data.ngayRaQuyetDinhGiaHan ? moment(Data.ngayRaQuyetDinhGiaHan).format('DD/MM/YYYY') : ''} />
                <TextMessage className="col-100 mb5" label="Lý do gia hạn:" value={Data.lyDonGiaHan ? Data.lyDonGiaHan : ''} />
              </div>
              <ShowIf condition={this.state.showFile && this.state.dataDetail.chuyenTheoDoiThucHien == false}>
                <div className='col-100 no-gutter'>
                  <ContainerFileDinhKem hideDescription={true} disableAttachFile={true} label="Danh sách văn bản xử lý" dataShow={Data.listTaiLieuVanThuGiaHan ? Data.listTaiLieuVanThuGiaHan : []} />
                </div>
              </ShowIf>
              <div className='col-100 no-gutter pt10 pb20'>
                <div className='line-border'></div>
              </div>
            </section>
          </ShowIf>
          <section className="wrap-block">
            <div className="row pl10 pr10 heading-addnew-dttt">
              <h2 className='title-13 col-100 pl20 pr20 mt10 mb15'>{this.state.type === 'KE_HOACH' ? (Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? `2.3 Căn cứ cuộc ${loaiCuocText}` : `2.2 Căn cứ cuộc ${loaiCuocText}`) : (Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? `1.3 Căn cứ cuộc ${loaiCuocText}` : `1.2 Căn cứ cuộc ${loaiCuocText}`)}</h2>
            </div>
            <div className="row pl10 pr10 ">
              <DataTable
                header={header.dsCanCuCuocThanhTraView}
                dataList={this.state.dataDetail.danhMucVanBans}
                hidePagination={true}
                parent={this}
              >
                <RowItemCanCuCuocThanhTraView />
              </DataTable>
            </div>
          </section>
          {/* Quyết định giám sát */}
          <section className="wrap-block">
            <div className="row pl10 pr10 heading-addnew-dttt">
              <h2 className='title-13 col-100 pl20 pr20 mt10 mb15'>{this.state.type === 'KE_HOACH' ? (Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '2.4 Quyết định giám sát' : '2.3 Quyết định giám sát') : (Data.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '1.4 Quyết định giám sát' : '1.3 Quyết định giám sát')}</h2>
            </div>
            <div className='pl20 pr20'>
              <ContainerFileDinhKem hideDescription={true} disableAttachFile={true} label="Danh sách văn bản xử lý" dataShow={Data.listTaiLieuVanThuQuyetDinhGiamSat ? Data.listTaiLieuVanThuQuyetDinhGiamSat : []} />
            </div>
          </section>
          {/*end Gia hạn*/}
          <ShowIf condition={Data && Data.tienDoThanhTraInfo && typeof Data.tienDoThanhTraInfo === 'object' && (Data.tienDoThanhTraInfo.type === 'DANG_THEO_DOI_THUC_HIEN' || Data.tienDoThanhTraInfo.type === 'LUU_HO_SO' || Data.tienDoThanhTraInfo.type === 'DANG_TIEN_HANH' || Data.tienDoThanhTraInfo.type === 'KET_THUC_THANH_TRA_TRUC_TIEP' || Data.tienDoThanhTraInfo.type === 'DA_BAN_HANH_KET_LUAN')}>
            {!isTTTW &&
              <div>
                <div className='row pl15 pr15'>
                  <h2 className='title-12 pl20 pr20 pb15'>{this.state.type === 'KE_HOACH' ? (Data.chucNangCuocThanhTra === 'CHUYEN_NGANH' ? `2.4. Thông báo kết thúc ${loaiCuocText} trực tiếp` : `2.3. Thông báo kết thúc ${loaiCuocText} trực tiếp`) : (Data.chucNangCuocThanhTra === 'CHUYEN_NGANH' ? `1.4. Thông báo kết thúc ${loaiCuocText} trực tiếp` : `1.3. Thông báo kết thúc ${loaiCuocText} trực tiếp`)}</h2>
                </div>
                <div className='row pl30 pr30'>
                  <div className='col-100 no-gutter'>
                    <Text label='Số thông báo:' className='col-25 mb10' value={Data.soThongBaoKetThucTTTT || ''} />
                    <Text label='Ngày ban hành:' className='col-25 mb10' value={Data.ngayBanHanhThongBaoKetThucTTTT ? moment(Data.ngayBanHanhThongBaoKetThucTTTT).format('DD/MM/YYYY') : ''} />
                  </div>
                  <TextMessage label='Ghi chú:' className='col-100 mb10' value={Data.ghiChu || ''} />
                </div>
                <ShowIf condition={this.state.showFile && this.state.dataDetail.chuyenTheoDoiThucHien == false}>
                  <div className='pl20 pr20'>
                    <ContainerFileDinhKem hideDescription disableAttachFile label="Danh sách văn bản xử lý" dataShow={Data.listTaiLieuVanThuThongBaoKetThucTTTT ? Data.listTaiLieuVanThuThongBaoKetThucTTTT : []} />
                  </div>
                </ShowIf>
              </div>
            }
          </ShowIf>
          {isTTTW &&
            <section className='wrap-block pb10'>
              <div className='big-border'></div>
              <div className='row pl15 pr15'>
                <h2 className='title-14 p20'>{this.state.type === 'KE_HOACH' ? `3. Kết luận ${loaiCuocText} rút gọn` : `2. Kết luận ${loaiCuocText} rút gọn`}</h2>
              </div>
              <div className='row pl30 pr30'>
                <div className='col-100 no-gutter'>
                  <Text label='Trạng thái:' className='col-25 mb10' value={textTrangThai} />
                  <Text label='Ngày thực hiện:' className='col-25 mb10' value={Data.ngayThucHienThanhTraRutGon ? moment(Data.ngayThucHienThanhTraRutGon).format('DD/MM/YYYY') : ''} />
                </div>
              </div>
              <div className='pl20 pr20'>
                <ContainerFileDinhKem hideDescription disableAttachFile label="Danh sách văn bản xử lý" dataShow={Data.listTaiLieuKetLuanThanhTraRutGon || []} />
              </div>
            </section>
          }

          <ShowIf condition={Data && Data.tienDoThanhTraInfo && typeof Data.tienDoThanhTraInfo === 'object' && (Data.tienDoThanhTraInfo.type === 'DANG_THEO_DOI_THUC_HIEN' || Data.tienDoThanhTraInfo.type === 'LUU_HO_SO' || Data.tienDoThanhTraInfo.type === 'KET_THUC_THANH_TRA_TRUC_TIEP' || Data.tienDoThanhTraInfo.type === 'DA_BAN_HANH_KET_LUAN')}>
            <div>
              <div className='big-border'></div>
              <ShowIf condition={Data && Data.soKetLuanThanhTra}>
                <section className='wrap-block pb10'>
                  <div className='row pl15 pr15'>
                    <h2 className='title-14 p20'>{isTTTW ? titleKetLuanThanhTraDayDu : titleKetLuanThanhTra}</h2>
                  </div>
                  <div className='row pl30 pr30'>
                    <div className='col-100 no-gutter'>
                      <Text label={`Số kết luận ${loaiCuocText}:`} className='col-25 mb10' value={Data.soKetLuanThanhTra || ''} />
                      <Text label='Ngày ban hành:' className='col-25 mb10' value={Data.ngayBanHanhKetLuanThanhTra ? moment(Data.ngayBanHanhKetLuanThanhTra).format('DD/MM/YYYY') : ''} />
                      <Text label='Đơn vị ban hành:' className='col-25 mb10' value={donViBanHanh} />
                    </div>
                    <div className='col-100 no-gutter'>
                      <Text label='Số quyết định xử lý:' className='col-25 mb10' value={Data.soQuyetDinhXuLy || ''} />
                      <Text label='Ngày ban hành:' className='col-25 mb10' value={Data.ngayBanHanhQuyetDinhXuLy ? moment(Data.ngayBanHanhQuyetDinhXuLy).format('DD/MM/YYYY') : ''} />
                    </div>
                    <TextMessage label={`Tóm tắt kết luận ${loaiCuocText}:`} className='col-100 mb10' value={Data.tomTatKetLuanThanhTra || ''} />
                  </div>
                  <ShowIf condition={this.state.showFile && this.state.dataDetail.chuyenTheoDoiThucHien != true}>
                    <div className='pl20 pr20'>
                      <ContainerFileDinhKem hideDescription disableAttachFile label="Danh sách văn bản xử lý" dataShow={Data.listTaiLieuVanThuKetLuanThanhTra ? Data.listTaiLieuVanThuKetLuanThanhTra : []} />
                    </div>
                  </ShowIf>
                </section>
              </ShowIf>
              <ShowIf condition={Data.noiDungKienNghi}>
                <div className='pl20 pr20'>
                  <div className='wrap-big-line'>
                    <div className='big-border'></div>
                  </div>
                  <h2 className='mb10 pt20 title-14'>{this.getTitleNoiDungKienNghi()}</h2>
                  <section className='wrap-block pb10'>
                    <div className='row pl15 pr15'>
                      <NoiDungKienNghi isTTTW={isTTTW} view={true} linhVucThanhTra={Data.linhVucThanhTra ? Data.linhVucThanhTra : ''} chucNangCuocThanhTra={Data.chucNangCuocThanhTra ? Data.chucNangCuocThanhTra : ''} listDoiTuongViPham={this.state.listDoiTuongViPham} onRef={noiDungKienNghi => (this.noiDungKienNghi = noiDungKienNghi)} type={this.state.type} id={this.state.id} />
                    </div>
                  </section>
                </div>
              </ShowIf>
              <ShowIf condition={Data.noiDungThamNhung}>
                <section className='row pl35 pr35 pb10'>
                  <div className='wrap-big-line mb20'>
                    <div className='big-border'></div>
                  </div>
                  <div className='col-100 no-gutter'>
                    <h2 className='title-14 mb10'>{this.getTitleNoiDungThamNhung()}</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Số vụ:" value={Data.soVuThamNhung ? Data.soVuThamNhung : ''} />
                      <Text className="col-25 mb10" label="Số đối tượng:" value={Data.soDoiTuongThamNhung ? Data.soDoiTuongThamNhung : ''} />
                      <div className="col-100 no-gutter">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Tài sản tham nhũng</p>
                        <Text className="col-25 mb10" label="Tiền (Trđ):" value={Data.tienThamNhung ? Data.tienThamNhung : ''} />
                        <Text className="col-25 mb10" label="Tài sản khác (Trđ):" value={Data.taiSanKhacThamNhung ? Data.taiSanKhacThamNhung : ''} />
                        <Text className="col-25 mb10" label="Đất (m2):" value={Data.datThamNhung ? Data.datThamNhung : ''} />
                      </div>
                      <div className="col-100 no-gutter">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị thu hồi</p>
                        <Text className="col-25 mb10" label="Tiền (Trđ):" value={Data.tienKienNghiThuHoi ? Data.tienKienNghiThuHoi : ''} />
                        <Text className="col-25 mb10" label="Tài sản khác (Trđ):" value={Data.taiSanKhacKienNghiThuHoi ? Data.taiSanKhacKienNghiThuHoi : ''} />
                        <Text className="col-25 mb10" label="Đất (m2):" value={Data.datKienNghiThuHoi ? Data.datKienNghiThuHoi : ''} />
                      </div>
                      <div className="col-100 no-gutter clear-left">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Đã thu</p>
                        <Text className="col-25 mb10" label="Tiền (Trđ):" value={Data.tienDaThu ? Data.tienDaThu : ''} />
                        <Text className="col-25 mb10" label="Tài sản khác (Trđ):" value={Data.taiSanKhacDaThu ? Data.taiSanKhacDaThu : ''} />
                        <Text className="col-25 mb10" label="Đất (m2):" value={Data.datDaThu ? Data.datDaThu : ''} />
                      </div>
                      <div className="col-50 no-gutter">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                        <Text className="col-50 mb10" label="Tổ chức:" value={Data.toChucXuLyHanhChinhThamNhung ? Data.toChucXuLyHanhChinhThamNhung : ''} />
                        <Text className="col-50 mb10" label="Cá nhân:" value={Data.caNhanXuLyHanhChinhThamNhung ? Data.caNhanXuLyHanhChinhThamNhung : ''} />
                      </div>
                      <div className="col-50 no-gutter">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý trách nhiệm người đứng đầu</p>
                        <Text className="col-50 mb10" label="Số người:" value={Data.soNguoiXuLyTrachNhiemDungDau ? Data.soNguoiXuLyTrachNhiemDungDau : ''} />
                        <Text className="col-50 mb10" label="Tên người:" value={Data.tenNguoi ? Data.tenNguoi : ''} />
                      </div>
                    </div>
                  </div>
                </section>
              </ShowIf>
              <ShowIf condition={this.state.showFile && this.state.dataDetail.chuyenTheoDoiThucHien == true}>
                <div className='pl20 pr20'>
                  <ContainerFileDinhKem hideDescription={true} disableAttachFile={true} label="Danh sách văn bản xử lý" dataShow={Data.listTaiLieuVanThu ? Data.listTaiLieuVanThu : []} />
                </div>
              </ShowIf>
            </div>
          </ShowIf>
        </div>
        <div className="action-form-wrap pt35 pb5">
          <div className="box-bottom">
            <Link className="btn-action btn-close" onClick={this.onClickClose.bind(this, 'close')}><span>Đóng</span></Link>
            <ShowIf condition={this.state.type === 'KE_HOACH' && DataDetail.chuyenTheoDoiThucHien !== true && DataDetail.tienDoThanhTra !== 'LUU_HO_SO'}>
              <Link className="btn-action btn-edit" to={`/thanh-tra/chinh-sua-cuoc-thanh-tra/${this.state.id}`}><span>Chỉnh sửa</span></Link>
            </ShowIf>
            <ShowIf condition={this.state.type === 'DOT_XUAT' && DataDetail.chuyenTheoDoiThucHien !== true && DataDetail.tienDoThanhTra !== 'LUU_HO_SO'}>
              <Link className="btn-action btn-edit" to={`/thanh-tra/chinh-sua-cuoc-thanh-tra-dot-xuat/${this.state.id}`}><span>Chỉnh sửa</span></Link>
            </ShowIf>
          </div>
        </div>
        <Dialog
          isOpen={this.state.showDoiTuongThanhTra}
          onClose={this.hideDoiTuongThanhTra.bind(this)}
          title={`Thông tin đối tượng ${loaiCuocText}`}
          className="reception-dialog delete-dialog full-dialog"
        >
          {
            DataDetail.cuocThanhTraNhieuDoiTuong === true ? (
              <table className="blueTable">
                <thead>
                  <tr>
                    <th style={{ width: '35px' }}>STT</th>
                    <th style={{ width: '300px' }}>Tên đối tượng</th>
                    <th style={{ width: '165px' }}>Nhóm đối tượng</th>
                    <th style={{ width: '165px' }}>Huyện/TP</th>
                    <th style={{ width: '165px' }}>Phường/Xã</th>
                    <th style={{ width: '375px' }}>Địa chỉ</th>
                    <th style={{ width: '135px' }}>Số điện thoại</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    DataDetail.listDoiTuongThanhTra &&
                    DataDetail.listDoiTuongThanhTra.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.ten}</td>
                        <td>{item.nhomDoiTuongThanhTraInfo && item.nhomDoiTuongThanhTraInfo.ten ? item.nhomDoiTuongThanhTraInfo.ten : ''}</td>
                        <td>{get(item, 'quanHuyenInfo.name')}</td>
                        <td>{get(item, 'phuongXaInfo.name')}</td>
                        <td>{item.diaChi}</td>
                        <td>{item.soDienThoai || ''}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            ) : (
              <div className="pt-dialog-body mb0">
                <div className='row pl15 pr15'>
                  <Text className='col-50 mb10' label='Tên đối tượng:' value={chiTietMotDoiTuong.ten || ''} />
                  <Text className='col-50 mb10' label='Nhóm đối tượng:' value={chiTietMotDoiTuong && chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo && chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten ? chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten : ''} />
                  <Text
                    className="col-50 mb10"
                    label="Huyện/TP:"
                    value={get(chiTietMotDoiTuong, 'quanHuyenInfo.name')} />
                  <Text
                    className="col-50 mb10"
                    label="Phường/Xã:"
                    value={get(chiTietMotDoiTuong, 'phuongXaInfo.name')} />
                  <Text className='col-50 mb10' label='Địa chỉ:' value={chiTietMotDoiTuong.diaChi || ''} />
                  <Text className='col-50 mb10' label="Số điện thoại:" value={chiTietMotDoiTuong && chiTietMotDoiTuong.soDienThoai ? chiTietMotDoiTuong.soDienThoai : ''} />
                </div>
              </div>
            )
          }
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.hideDoiTuongThanhTra.bind(this)}><span>Đóng</span></Link>
          </div>
        </Dialog>
      </div>
    );
  }
}

ChiTietCuocThanhTra.defaultProps = {
  validators: {},
  type: 'DOT_XUAT'
}

export default connect()(ChiTietCuocThanhTra);



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/ChiTietCuocThanhTra.jsx